export default {
  pendingAgreementDocuments: JSON.parse(localStorage.getItem('agreementDocuments')) || [],
  pendingHtmlDocuments: [],
  error: {}
}